export function prefixMethods (methods, prefix) {
  return Object.keys(methods).reduce((acc, curr) => {
    acc[`${prefix}${curr}`] = methods[curr];

    return acc;
  }, {});
}